import { getId, getWithCode, isDefined } from 'services/utils'
import { uploadOrKeepMultipleImgs } from '../../common'
import { parseImage } from '../utils'
import { APIFacet } from '../facets'
import { ProductCommonToAPI } from './types/api/request-models'
import { APIProductCommon } from './types/api/response-models'
import { ProductCommon } from './types/internal/productCommon-models'

// ============
// UTILS
// ============

export const getFacetsWithCodes = (facets: APIFacet[]) => ({
  facets: facets.map(getId),
  facetCodes: facets.map(getWithCode),
})

// ============
// PARSE
// ============

export const productCommonParse = (res: APIProductCommon): ProductCommon => ({
  ...res,
  ...getFacetsWithCodes(res.facets),
  images: res.images.map(parseImage).filter(isDefined),
})

// ============
// WRITE
// ============

export const productCommonWrite = async (
  req: ProductCommon
): Promise<ProductCommonToAPI> => ({
  ...req,
  images: await uploadOrKeepMultipleImgs(req.images ?? []),
})
